import { Message } from 'element-ui';
export function handleError(error) {
    let errorMessage = '请求出错了，请联系管理员！';
    if (error.response != null) {
        let response = error.response, status = error.response.status;
        errorMessage = error.response.statusText;
        switch (status) {
            case 400:
            case 500:
                if (response.data != null) {
                    if (response.data.message != null) {
                        errorMessage = response.data.message;
                    }
                    if (response.data.errorMessage != null) {
                        errorMessage = response.data.errorMessage;
                    }
                    if (response.data.responseMessage != null) {
                        errorMessage = response.data.responseMessage;
                    }
                }
        }
    }
    Message.error(errorMessage);
}
